export default __webpack_public_path__ + "8df6f5f272287ede6b2903b753d2beaa.svg";